<template>
  <!-- Material 3 navigation by window size class: a bottom navigation bar
       when compact (< 600px), a rail when medium or expanded, a standard
       drawer when large (>= 1200px). Each screen has its own top bar. -->
  <nav-drawer
    v-if="navigation === 'drawer'"
    :key="profile?.uid"
    :profile="profile"
    :items="items"
  />
  <nav-rail v-if="navigation === 'rail'" :items="items" />
  <v-main>
    <offline-notification />
    <slot />
  </v-main>
  <nav-bottom :items="items" :active="navigation === 'bar'" />
</template>

<script lang="ts">
  import NavDrawer from '@/components/infrastructure/nav-drawer/NavDrawer.vue';
  import NavRail from '@/components/infrastructure/nav-rail/NavRail.vue';
  import { computed, defineComponent, type PropType } from 'vue';
  import { useAuthStore } from '@/stores/auth';
  import { useDisplay } from 'vuetify';
  import type { ClientInterface } from '@/service/types';
  import type { Profile, ProfilePayload } from '@/service/profile/types';
  import { useProfileStore } from '@/stores/profile';
  import NavBottom from '@/components/infrastructure/nav-bottom/NavBottom.vue';
  import OfflineNotification from '@/components/offline-notification/OfflineNotification.vue';

  export default defineComponent({
    name: 'MainView',
    components: {
      OfflineNotification,
      NavBottom,
      NavDrawer,
      NavRail,
    },
    props: {
      client: {
        type: Object as PropType<ClientInterface<Profile, ProfilePayload>>,
        required: true,
      },
    },
    setup(props) {
      const authStore = useAuthStore();
      const profileStore = useProfileStore(props.client);
      const profile = profileStore.getProfile();
      const { width } = useDisplay();
      const navigation = computed(() => {
        if (width.value < 600) return 'bar';
        if (width.value < 1200) return 'rail';
        return 'drawer';
      });

      return {
        navigation,
        profile,
        items: [
          {
            icon: 'mdi-book-open-variant',
            title: 'Recipe',
            value: 'recipe',
          },
          {
            icon: 'mdi-calendar-week',
            title: 'Week Plan',
            value: 'weekplan',
          },
          {
            icon: 'mdi-cart',
            title: 'Groceries',
            value: 'groceries',
          },
          {
            icon: 'mdi-account',
            title: 'Profile',
            value: 'profile',
          },
        ],
        logout: async function () {
          await authStore.logout();
        },
      };
    },
  });
</script>
